import axios from 'axios';
import { req } from './axiosFun';

/**
 * 编号管理 - 替换列表
 **/
// 获取替换列表
export const campList = (params) => { return axios.get("/customer/listTr") };
export const campListSave  = (params) => { return req("post", "/customer/addTr", params) };
export const campListUp    = (params) => { return req("post", "/customer/updateTr", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteTr", params) };



// WEBPACK FOOTER //
// ./src/api/campsMG17.js